/* eslint-disable react/destructuring-assignment */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RouterContext } from 'react-router';
import { ReactReduxContext } from 'react-redux';
import { loadAsyncConnect } from '../helpers/utils';
import { getMutableState } from '../helpers/state';

export class AsyncConnect extends Component {
  static propTypes = {
    render: PropTypes.func,
    beginGlobalLoad: PropTypes.func.isRequired,
    endGlobalLoad: PropTypes.func.isRequired,
    reloadOnPropsChange: PropTypes.func,
    location: PropTypes.object.isRequired,
    /* eslint-disable react/forbid-prop-types, react/no-unused-prop-types */
    components: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    helpers: PropTypes.any,
    /* eslint-enable react/forbid-prop-types, react/no-unused-prop-types */
  };

  static defaultProps = {
    helpers: {},
    reloadOnPropsChange() {
      return true;
    },
    render(props) {
      return <RouterContext {...props} />;
    },
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      propsToShow: this.isLoaded() ? props : null,
    };

    this.mounted = false;
    this.loadDataCounter = 0;
  }

  componentDidMount() {
    this.mounted = true;
    const dataLoaded = this.isLoaded();

    // we dont need it if we already made it on server-side
    if (!dataLoaded) {
      this.loadAsyncData(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    const navigated = this.props.location !== nextProps.location;

    // Allow a user supplied function to determine if an async reload is necessary
    if (navigated && this.props.reloadOnPropsChange(this.props, nextProps)) {
      this.loadAsyncData(nextProps);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.propsToShow !== nextState.propsToShow;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  isLoaded() {
    const { reduxConnectStore } = this.props;

    return getMutableState(reduxConnectStore.getState()).reduxAsyncConnect
      .loaded;
  }

  loadAsyncData({ reduxConnectStore, ...props }) {
    const loadResult = loadAsyncConnect({ ...props, store: reduxConnectStore });

    // TODO: think of a better solution to a problem?
    this.loadDataCounter += 1;
    this.props.beginGlobalLoad();

    return (loadDataCounterOriginal =>
      loadResult.then(() => {
        // We need to change propsToShow only if loadAsyncData that called this promise
        // is the last invocation of loadAsyncData method. Otherwise we can face a situation
        // when user is changing route several times and we finally show him route that has
        // loaded props last time and not the last called route
        if (
          this.loadDataCounter === loadDataCounterOriginal &&
          this.mounted !== false
        ) {
          this.setState({ propsToShow: props });
        }

        // TODO: investigate race conditions
        // do we need to call this if it's not last invocation?
        this.props.endGlobalLoad();
      }))(this.loadDataCounter);
  }

  render() {
    const { propsToShow } = this.state;

    return propsToShow && this.props.render(propsToShow);
  }
}

const AsyncConnectWithContext = ({ context, ...otherProps }) => {
  const Context = context || ReactReduxContext;

  if (Context == null) {
    throw new Error('Please upgrade to react-redux v6');
  }

  return (
    <Context.Consumer>
      {({ store: reduxConnectStore }) => (
        <AsyncConnect reduxConnectStore={reduxConnectStore} {...otherProps} />
      )}
    </Context.Consumer>
  );
};

AsyncConnectWithContext.propTypes = {
  context: PropTypes.object,
};

export default AsyncConnectWithContext;
